export const lastSeenOf = (u) => u.last_seen_at ?? u.last_login_at ?? u.last_login ?? u.last_active_at ?? null;

export const usagePctOf = (u) => {
  if (u.usage_percent_30d != null) return Math.round(u.usage_percent_30d);
  if (u.active_days_30d != null) return Math.min(100, Math.round((u.active_days_30d / 30) * 100));
  return null;
};

export const isExamSession = (s) => /exam/i.test(s.mode ?? "");
